var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCategoryTravel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.25h-5.834V7.5h-1.25V1.25h-6.25l-.01 7.5H1.25v9.987H0V7.487h4.176L4.166 0h8.75v4.987H20v13.75h-1.25V6.25ZM2.5 9.987h1.25v1.25H2.5v-1.25ZM9.166 5h1.25v1.25h-1.25V5Zm-2.5 0h1.25v1.25h-1.25V5Zm9.584 2.487h1.25v1.25h-1.25v-1.25Zm0 2.5h1.25v1.25h-1.25v-1.25Zm-9.584-7.5 1.25.013v1.25h-1.25V2.487Zm2.5.013h1.25v1.25h-1.25V2.5Zm1.928 5.834A3.886 3.886 0 0 1 15 12.084v1.25h1.25c.46 0 .834.372.834.832V17.5c0 .46-.373.834-.834.834V20h-2.5v-1.668h-7.5V20h-2.5v-1.666a.833.833 0 0 1-.834-.834v-3.334c0-.46.373-.832.834-.832H5v-1.25a3.886 3.886 0 0 1 3.907-3.75h2.187Zm5.156 9.153v-.82h-3.125v-.014a.415.415 0 0 0-.32-.404l-.096-.012H7.29a.416.416 0 0 0-.416.417v.012H3.75v.82h12.5ZM5.182 14.258a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Zm9.61 0ZM10 9.584c-3.536 0-3.737 1.64-3.75 3.424v.326h7.5c0-1.907 0-3.75-3.75-3.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryTravel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/category-travel.b75bfd3555f3647bdc26dd8df3e80ce9.svg";